import { AnalyticsPlugin, isToggleOn, TrackerConfigurations } from '@pulse/common';
import { ActivitySynchronizer } from '../services/activity.synchronizer';
import { TabInfoService, TabManagerService } from '../services/tabs';

export class TabLinkingPlugin implements AnalyticsPlugin {
    constructor(
        private activity: ActivitySynchronizer,
        private tabInfo: TabInfoService,
        private tabManager: TabManagerService,
        private config: TrackerConfigurations,
    ) {}

    init() {
        if (isToggleOn(this.config.eventEnrichment, 'tab_id')) {
            this.activity.startService(this.tabManager.getTabId());
            this.tabInfo.startService(this.tabManager.getTabId());
        }
    }
}
